import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export type ToasterType = 'success' | 'error' | 'info' | 'warning';

export interface ToasterData {
  message: string;
  type: ToasterType;
}

@Component({
  selector: 'app-toster',
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
  templateUrl: './toster.html',
  styleUrl: './toster.scss'
})
export class Toster {
  snackBarRef = inject(MatSnackBarRef);
  
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: ToasterData) { }
}
